import moment from "moment";

/**
 * Parse a timestamp string (append 'Z' if no timezone present) and format using moment.
 * Returns a string like '11-Feb-2026 18:06:20 +01:00' using the client's local offset.
 * Returns null for invalid input.
 */
export function formatWithMomentAndOffset(input) {
  try {
    if (!input && input !== 0) return null;
    let s = String(input).trim();

    // If the string doesn't already contain a timezone designator or offset, append 'Z' to treat it as UTC
    // Matches: trailing 'Z' or an offset like +05:30 or -0230
    const hasTZ = /[zZ]$|[+\-]\d{2}:?\d{2}$/.test(s);
    if (!hasTZ) s = s + "Z";

    const m = moment(s);
    if (!m.isValid()) return null;

    // Format: Day-Month-Year Hours:Minutes:Seconds Offset
    // Example: 11-Feb-2026 18:06:20 +01:00
    return m.format("DD-MMM-YYYY HH:mm:ss");
  } catch (e) {
    return null;
  }
}

export default formatWithMomentAndOffset;

/**
 * Parse an ISO timestamp (UTC) and return a Date set to local midnight
 * for the same UTC calendar date. This ensures UI date-only controls
 * show the same calendar date regardless of client timezone.
 */
export function parseISOToLocalDateAtMidnightUTC(input) {
  if (!input) return null;
  const d = new Date(input);
  if (Number.isNaN(d.getTime())) return null;
  const y = d.getUTCFullYear();
  const m = d.getUTCMonth();
  const day = d.getUTCDate();
  return new Date(y, m, day);
}
